import { useEffect } from 'react'
import buildCompanyName from '../../../utilities/buildCompanyName'
import { ctsView } from '../storage'
import { GetInvoice } from '../type'
import GeneralInformation from './GeneralInformation'
import Products from './Products'

ctsView.setSection('Información general', GeneralInformation)
ctsView.setSection('Productos', Products)

export default function ModalInfo({ data }: { data: GetInvoice }) {
    const value = ctsView.useStep()
    useEffect(() => {
        return () => {
            ctsView.value = 'step1'
        }
    })

    return (
        <>
            <div className="body__head">
                <div className="title">
                    <h1>FACTURA {data.invoice_number}</h1>
                </div>
                <div>
                    <div className="company_badge">
                        <img src={data.company.country.image_url} />
                        <b>{buildCompanyName(data.company.name)}</b>
                    </div>
                </div>
            </div>
            <ctsView.SectionTabs
                value={value}
                type="tab"
                mode="simple"
                className="mb-4"
                data={data}
            />
        </>
    )
}
